import React from 'react';
import theme from '../theme';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';

const imgService = require('../assets/logo.png');

const styles = {
  root: {
    flexGrow: 1,
    background: 'white',
    color: 'white',
  },
  logo: {
    width: 300,
  },
  toolbar: {
    background: 'white',
    minHeight: 40,
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
};


function TopBar(props) {
  const { classes } = props;

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Toolbar className={classes.toolbar}>
          <Box p={1} flexGrow={1}> <img src={imgService} alt="" className={classes.logo} /></Box>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default withStyles(styles)(TopBar);